import { IApplicationState } from '../../../types/redux';

/**
 * Выбирает текущий пост (для страницы карточки поста)
 */
export const selectCurrentPost = ({ postCard }: IApplicationState) => postCard.item;
